export const FormatDecimal = (string: any) => {
  const number =
    typeof string === 'string'
      ? parseFloat(string?.replace(/\./g, '').replace(',', '.'))
      : string;
  if (number && !isNaN(number)) {
    const partes = number
      .toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      .split('.');

    const int = partes[0].replace(/,/g, '.');
    const decimal = partes[1];

    return `${int},${decimal}`;
  } else {
    return '';
  }
};
export const FormatDecimalWithDot = (string: string) => {
  let text = string.replace(/\./g, '');
  if (!text.includes(',')) {
    text = text + '.00';
  } else {
    const parts = text.split(',');
    if (parts[1].length === 1) {
      text = `${parts[0]}.${parts[1]}0`;
    } else {
      text = text.replace(',', '.');
    }
  }
  return text;
};
